import { FieldHint } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/components/FieldHint';
import { Text } from '@/components/shared/components/Text';

interface PreviousValueHintProps {
  previousValue?: string;
}

export const PreviousValueHint = ({ previousValue }: PreviousValueHintProps) => {
  if (!previousValue) return null;

  return (
    <FieldHint>
      <Text tId="PREVIOUS_VALUE" dynamicDataTexts={[previousValue]} />
    </FieldHint>
  );
};
